<div class="ehe">
	<!-- MFA Input Component -->
	<div *ngIf="displayMfaInputScreen">
		<app-mfa-input-screen></app-mfa-input-screen>
	</div>
	<router-outlet></router-outlet>
</div>
<!--<app-ehe-footer></app-ehe-footer>-->
